import { render, staticRenderFns } from "./DetailsFastener.vue?vue&type=template&id=011eb8e0&scoped=true&"
import script from "./DetailsFastener.vue?vue&type=script&lang=js&"
export * from "./DetailsFastener.vue?vue&type=script&lang=js&"
import style0 from "./DetailsFastener.vue?vue&type=style&index=0&id=011eb8e0&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011eb8e0",
  null
  
)

export default component.exports